<div class="c-unit">
	<button (click)="subtract()">-</button>
	<input (focusout)="validate()" [formControl]="control" [max]="max" [min]="min" autocomplete="off" data-1p-ignore
				 type="number">
	<button (click)="add()">+</button>

	<span *ngIf="unit">{{ unit }}</span>
</div>
